import React, { useState } from 'react'
import _ from 'lodash'
import {
  Div, Icon, Button, H4,
} from 'konsys-ui'
import { message } from 'antd'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { CREATE_WAREHOUSE, UPDATE_WAREHOUSE } from '../../../constants/graph/mutation'
import { WAREHOUSE, WAREHOUSES } from '../../../constants/graph/query'
import { detailMode } from '../constants'
import { verifyFields, checkFloat, checkInt } from '../../../utils/util-services'
import {
  TextareaWithLabel, FullPageContainer, Divider, InputWithLabel,
} from '../../../components/common'
import history from '../../../history'

const Render = ({
  isCreateMode, infoData, mutationLoading, doAction, props,
}) => {
  const [mutationVariables, setMutationVariables] = useState(isCreateMode ? {} : {
    warehouseCode: infoData.findWarehouse.data.warehouseCode,
    warehouseName: infoData.findWarehouse.data.warehouseName,
  })
  const baseRequiredFields = [
    mutationVariables.warehouseCode,
    mutationVariables.warehouseName,
  ]
  return (
    <Div display='flex' flexDirection='column' padding='0 60px'>
      <InputWithLabel
        input={{
          width: '100%',
          defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.warehouseCode,
        }}
        onChange={(e) => {
          setMutationVariables({ ...mutationVariables, warehouseCode: e.target.value })
        }}
        title={{ text: 'รหัสคลังสินค้า *' }}
      />
      <InputWithLabel
        input={{
          width: '100%',
          prefix: <Icon icon='prefix far fa-font' />,
          defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.warehouseName,
        }}
        onChange={e => setMutationVariables({ ...mutationVariables, warehouseName: e.target.value })}
        title={{ text: 'ชื่อคลังสินค้า *' }}
      />

      <Divider
        // color='#C2E2BF'
        margin='40px 0'
      />
      <InputWithLabel
        input={{
          width: '100%',
          defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.address.addressNo,
        }}
        onChange={e => setMutationVariables({ ...mutationVariables, addressNo: e.target.value })}
        title={{ text: 'เลขที่' }}
      />
      <InputWithLabel
        input={{
          width: '100%',
          defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.address.subDistrict,
        }}
        onChange={e => setMutationVariables({ ...mutationVariables, subDistrict: e.target.value })}
        title={{ text: 'แขวง/ตำบล' }}
      />
      <InputWithLabel
        input={{
          width: '100%',
          defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.address.district,
        }}
        onChange={e => setMutationVariables({ ...mutationVariables, district: e.target.value })}
        title={{ text: 'เขต/อำเภอ' }}
      />
      <InputWithLabel
        input={{
          width: '100%',
          defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.address.province,
        }}
        onChange={e => setMutationVariables({ ...mutationVariables, province: e.target.value })}
        title={{ text: 'จังหวัด' }}
      />
      <InputWithLabel
        input={{
          width: '100%',
          defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.address.postcode,
        }}
        onChange={e => setMutationVariables({ ...mutationVariables, postcode: e.target.value })}
        title={{ text: 'รหัสไปรษณีย์' }}
      />
      <TextareaWithLabel
        margin='8px 0'
        onChange={e => setMutationVariables({ ...mutationVariables, contactRemark: e.target.value })} title={{
          text: 'หมายเหตุ',
        }} textarea={{
          style: { width: '100%' },
          rows: 8,
          margin: '8px 0 0',
          defaultValue: isCreateMode ? undefined : infoData.findWarehouse.data.address.contactRemark,
        }}
      />
      <Button
        loading={mutationLoading}
        text={isCreateMode ? 'สร้างคลังสินค้า' : 'แก้ไขคลังสินค้า'}
        disabled={verifyFields(isCreateMode, baseRequiredFields, baseRequiredFields)}
        icon={isCreateMode ? 'far fa-plus' : 'far fa-edit'}
        style={{ alignItems: 'center' }}
        width='fit-content'
        margin='20px auto'
        onClick={() => {
          doAction({
            variables: isCreateMode ? { ...mutationVariables } : { ...mutationVariables, id: parseInt(props.match.params.id, 10) },
            refetchQueries: [{ query: WAREHOUSES, variables: { limit: 5, offset: 0 } }],
          }).then((resp) => {
            const KEY = isCreateMode ? 'createWarehouse' : 'updateWarehouse'
            if (resp.data[KEY].success) {
              message.success(resp.data[KEY].message)
              history.push('/warehouse')
            } else message.error(resp.data[KEY].message)
          })
        }}
      />
    </Div>
  )
}

export default ({ props }) => {
  const isCreateMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const [doAction, { loading: mutationLoading }] = useMutation(isCreateMode ? CREATE_WAREHOUSE : UPDATE_WAREHOUSE)
  const { loading, data, error } = useQuery(WAREHOUSE, { skip: isCreateMode, variables: { id: parseInt(props.match.params.id, 10) } })

  return (
    <Div>
      {
        !loading
          ? !isCreateMode && _.isNull(data.findWarehouse.data)
            ? <H4>ไม่พบ</H4>
            : <Render
              infoData={data}
              mutationLoading={mutationLoading}
              doAction={doAction}
              props={props}
              isCreateMode={isCreateMode}
              />
          : null
      }
    </Div>
  )
}
